// FNP-904. The console reads signatures and writes exactly ONE field pair on
// them (status + jiraKey) via updateDefectSignature.
//
// It deliberately does NOT call `recordDefectOccurrence` or
// `resolveDefectSignature` — both are @aws_iam-only and belong to the sweep.
// "This defect is fixed" must be an evidence-based conclusion drawn from an
// absence of occurrences, never a button a human clicks.

const DEFECT_SIGNATURE_FIELDS = `
    id
    actionCode
    sampleError
    normalizedError
    outcome
    verificationResult
    firstSeenAt
    lastSeenAt
    occurrenceCount
    distinctUserCount
    status
    jiraKey
    resolvedAt
    created
    updated
`;

export const listDefectSignatures = `
   query listDefectSignatures($filter: DefectSignaturesFilterInput, $limit: Int, $nextToken: String) {
       listDefectSignatures(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {${DEFECT_SIGNATURE_FIELDS}}
           nextToken
       }
   }
`;

export const getDefectSignature = `
   query getDefectSignature($id: ID!) {
       getDefectSignature(id: $id) {${DEFECT_SIGNATURE_FIELDS}}
   }
`;
